(function ($, Drupal, drupalSettings) {

  /**
   * If a user is attempting to leave the site and go to a sibling site, present the user with a confirmation modal
   *
   * @type {{attach: attach}}
   */
  Drupal.behaviors.leavingSiteModal = {
    attach: function attach(context, settings) {
      const regionSelector = '#block-regionselection';
      const modalSelector = '#block-leavingsitemodal';
      const siteContinueSelector = '.js-site-continue';
      const dropdownMenu = $(regionSelector).find('.menu.dropdown-menu a');

      $(dropdownMenu, context).click(function (e) {
        e.preventDefault();
        let link = $(this).attr('href');
        let target = $(this).attr('target');
        let drupalData = $(this).attr('data-drupal-link-system-path');

        if ( (target != '_self') || (drupalData != '<front>') ) {
          $(modalSelector).find(siteContinueSelector).attr('href', link);
          $(modalSelector).modal('show');
        } else {
          window.location = this.href;
        }
      });
    }
  };

})(jQuery, Drupal, drupalSettings);
